import { render, staticRenderFns } from "./PersonDialogContactTabComponent.vue?vue&type=template&id=9c1c40b8&scoped=true"
import script from "./PersonDialogContactTabComponent.js?vue&type=script&lang=js&external"
export * from "./PersonDialogContactTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./PersonDialogContactTabComponent.vue?vue&type=style&index=0&id=9c1c40b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1c40b8",
  null
  
)

export default component.exports